import { de } from './i18n/de';

export const translations = { de };

export const getTranslation = (language, key) => {
  const keys = key.split('.');
  let value = translations.de;
  
  for (const k of keys) {
    value = value?.[k];
    if (value === undefined) {
      return key;
    }
  }
  
  return value || key;
};

export default translations;
